"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GoalWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var GoalWidget = function GoalWidget(_ref) {
  var title = _ref.title,
      value = _ref.value,
      size = _ref.size,
      subtitle = _ref.subtitle,
      strokeWidth = _ref.strokeWidth,
      extra = _ref.extra;
  return /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, title && /*#__PURE__*/_react.default.createElement("h4", {
    className: "mb-3 font-weight-bold"
  }, title), /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    type: "dashboard",
    percent: value,
    width: size,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-2 mx-auto text-muted ".concat(extra ? 'mb-3' : ''),
    style: {
      maxWidth: "".concat(size + 30, "px")
    }
  }, subtitle), extra));
};

exports.GoalWidget = GoalWidget;
GoalWidget.defaultProps = {
  strokeWidth: 4,
  size: 150
};
var _default = GoalWidget;
exports.default = _default;